import React, { useContext } from "react";
import { AppContext } from "../App";
import logo from "../assets/logo.png";
import { MdClose, MdHome, MdInfoOutline, MdLayers, MdOutlinePhoneInTalk } from "react-icons/md";

export default function SideBar(props) {
  const appContext = useContext(AppContext);

  function openSideBar() {
    appContext.setIsSideBarOpen(true);
  }

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({ item });

    if (appContext.isSideBarOpen) {
      closeSideBar();
    }
  }

  // Unified data matrix to handle navigation items dynamically and cleanly
  const navItems = [
    { key: "home", label: "Home", icon: <MdHome size={20} /> },
    { key: "about_us", label: "About Us", icon: <MdInfoOutline size={20} /> },
    { key: "services", label: "Services", icon: <MdLayers size={20} /> },
    { key: "contact_us", label: "Contact Us", icon: <MdOutlinePhoneInTalk size={20} /> },
  ];

  const currentActive = appContext.navItem || "home";

  return (
    <>
      <style>{`
        /* Encapsulated styling blocks targeting inner selectors without touching top layout overrides */
        .SideBar .side-close-trigger {
          color: #ED8936;
          transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), color 0.3s ease;
          display: flex;
          justify-content: flex-end;
          padding: 8px;
          margin-bottom: 24px;
        }

        .SideBar .side-close-trigger svg:hover {
          color: #ED8936;
          transform: rotate(90deg);
        }

        .SideBar .side-nav-container {
          display: flex;
          flex-direction: column;
          gap: 6px;
          padding: 0 4px;
        }

        .SideBar .pill {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 14px 20px;
          border-radius: 4px;
          cursor: pointer;
          position: relative;
          background: transparent;
          border: 1px solid transparent;
          transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
          box-sizing: border-box;
        }

        .SideBar .pill:hover {
          background: rgba(17, 26, 46, 0.4);
          transform: translateX(6px);
        }

        .SideBar .pill[data-active="true"] {
          background: #111A2E;
          border-color: rgba(56, 161, 105, 0.2);
        }

        /* Discrete modern vertical indicator tracking active route */
        .SideBar .pill::before {
          content: '';
          position: absolute;
          left: 0;
          top: 30%;
          bottom: 30%;
          width: 3px;
          background-color: #38A169;
          border-radius: 0 2px 2px 0;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .SideBar .pill[data-active="true"]::before {
          opacity: 1;
        }

        .SideBar .pill .pill-icon {
          color: #4A5568;
          display: flex;
          align-items: center;
          transition: color 0.4s ease;
        }

        .SideBar .pill:hover .pill-icon {
          color: #ED8936;
        }

        .SideBar .pill[data-active="true"] .pill-icon {
          color: #38A169;
        }

        .SideBar .pill .text {
          margin: 0;
          font-family: 'Libre Franklin', sans-serif;
          font-size: 0.95rem;
          font-weight: 400;
          letter-spacing: 0.02em;
          color: #A0AEC0;
          transition: color 0.4s ease;
        }

        .SideBar .pill:hover .text {
          color: #ED8936;
        }

        .SideBar .pill[data-active="true"] .text {
          color: #FFFFFF;
          font-weight: 500;
        }

        .SideBar .side-meta-footer {
          margin-top: auto;
          padding: 24px 20px 8px;
          border-top: 1px solid rgba(30, 45, 74, 0.4);
        }

        .SideBar .side-meta-tag {
          font-size: 0.65rem;
          text-transform: uppercase;
          letter-spacing: 0.12em;
          color: #4A5568;
          margin: 0;
        }
      `}</style>

      <div
        className="SideBar mShadow2"
        data-open={appContext.isSideBarOpen}
      >
        <div className="body mNoScrollBar d-flex flex-column h-100">
          
          {/* Responsive Menu Close Action Block */}
          <div className="side-close-trigger">
            <MdClose 
              size={24}
              onClick={appContext.closeSideBar}
              style={{ cursor: "pointer" }}
            />
          </div>

          {/* Minimalist Structural Wordmark Placeholder */}
          <div className="d-flex justify-content-center py-3">
            <img src={logo} width={100} />
          </div>

          {/* Navigation Matrix Wrapper */}
          <nav className="side-nav-container" aria-label="Mobile Navigation Matrix">
            {navItems.map((item) => (
              <div
                key={item.key}
                className="pill"
                onClick={() => goTo(item.key)}
                data-active={currentActive === item.key}
              >
                <span className="pill-icon" aria-hidden="true">
                  {item.icon}
                </span>
                <p className="text">{item.label}</p>
              </div>
            ))}
          </nav>

          {/* Clean Corporate Meta Bottom Anchor */}
          <div className="side-meta-footer">
            <p className="side-meta-tag">© Tanzavibe Holdings Ltd</p>
          </div>

        </div>
      </div>
    </>
  );
}